import type { InjectionKey, Plugin } from 'vue';
import type { Router } from 'vue-router';

import { AppTrackingContext, Tracker } from './Tracker';
import {
  ClickTrackingListener,
  TrackRegistry,
  createTrackDirective,
} from './trackDirective';
import type { TrackingDestination } from './destinations/TrackingDestination';

export const TRACKER_KEY: InjectionKey<Tracker> = Symbol('tracker');

interface AnalyticsOptions {
  router: Router;
  destinations: readonly TrackingDestination[];
}

export function createAnalytics({
  router,
  destinations,
}: AnalyticsOptions): Plugin {
  return {
    install(app) {
      const tracker = new Tracker(new AppTrackingContext(router), destinations);
      const registry = new TrackRegistry();

      new ClickTrackingListener(registry, tracker).attach();

      app.directive('track', createTrackDirective(registry));
      app.provide(TRACKER_KEY, tracker);
      app.config.globalProperties.$track = tracker.track;
    },
  };
}
